/** POST /support — send a support message */

import config from "../config";


const BASE_URL = config.backendUrl;

export interface ContactSupportPayload {
  email: string;
  subject: string;
  message: string;
};

export async function sendSupportMessage(
  payload: ContactSupportPayload
): Promise<void> {
  const response = await fetch(`${BASE_URL}/support`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error(`Failed to send support message: ${response.statusText}`);
  }
};